export const RECEIPT_ROUTES = {
  myList: '/staff/receipts',
  new: '/staff/receipts/new',
  inbox: '/staff/receipts/inbox',
  detail: '/staff/receipts/:id',
} as const;

/** Build a concrete detail path for a receipt id. */
export const receiptDetailPath = (id: string): string => `/staff/receipts/${id}`;
